import React from "react";

import VerticalSpace from "../VerticalSpace";

import "./radiobutton.sass";

function RadioButton(props) {
  const {
    title,
    itemclass,
    column = false,
    checkedValue,
    change,
    required,
    data,
    // marginLeft = "",
    // marginRight = "1rem",
    // marginBottom = 0,
    // fontFamily,
    fontSize,
    error,
    node = null,
  } = props;

  return (
    <div className=''>
      <div>
        {title}
        {required ? <span className='input-required-sign'>*</span> : ""}
      </div>

      <div
        className={`radio-button-itams-box flex justify-center text-sm w-full  ${
          column ? "flex-col" : "flex-col md:flex-row gap-2"
        }`}
        style={{ fontSize }}
      >
        {data?.map((item, index) => {
          return (
            <div
              key={item.value}
              className={`radio-button-itams ${itemclass} ${
                checkedValue === item.value ? "color-blue" : ""
              }`}
            >
              <input
                className='radio-button-input'
                type='radio'
                name={item.id || item.value}
                id={item.id || item.value}
                checked={checkedValue === item.value}
                onChange={() => change(item.value)}
              />

              <label
                htmlFor={item.value}
                className='radio-button-label'
                ref={node}
              >
                {item.label}
              </label>
            </div>
          );
        })}
      </div>

      {error ? (
        <>
          <VerticalSpace space='1rem' />
          <span className='input-error-text'>{error}</span>
        </>
      ) : (
        ""
      )}
    </div>
  );
}
export default RadioButton;
